import { createApp } from 'vue';
import * as directives from './directives';
import * as components from './components';
import { formVisibilityHandler } from './directives/formVisibilityHandler';
import './styling/main.scss';

const app = createApp({
  directives,
  components: {
    ...components,
  },
});

if (process.env.NODE_ENV === 'development') {
  app.config.performance = true;
}

app.mount('#app');

document.addEventListener('DOMContentLoaded', () => {
  // Handle EPI server custom functionality
  formVisibilityHandler();
});
